'use client'

import { useEffect, useState } from 'react'

type StripPartner = { name: string; logoUrl: string | null }

/**
 * "Welcome, <partner> guests" on checkout. Fetched after mount from an
 * uncached route so no partner name is ever in the page HTML (spec D14).
 */
export default function PartnerStrip() {
  const [partner, setPartner] = useState<StripPartner | null>(null)
  useEffect(() => {
    let live = true
    fetch('/api/partner-strip', { cache: 'no-store', credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : null))
      .then((j: { partner?: StripPartner | null } | null) => { if (live) setPartner(j?.partner ?? null) })
      .catch(() => {})
    return () => { live = false }
  }, [])
  if (!partner) return null
  return (
    <div
      role="note"
      className="flex items-center gap-3 rounded-xl border border-[var(--color-border)] bg-[var(--color-bg-primary)] px-4 py-2.5 text-sm text-[var(--color-text-secondary)]"
    >
      {partner.logoUrl ? (
        // A small logo already sized by the media worker; next/image adds nothing here.
        // eslint-disable-next-line @next/next/no-img-element
        <img src={partner.logoUrl} alt="" className="h-6 w-auto max-w-[96px] object-contain" />
      ) : null}
      <span>Welcome, {partner.name} guests</span>
    </div>
  )
}
